import React from "react";
import { Button } from "reactstrap";
import {
  FaCashRegister,
  FaUndo,
  FaMoneyBillWave,
  FaSignOutAlt,
  FaStore,
  FaArrowLeft,
  FaCubes,
  FaProductHunt,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { authActions } from "../../sagas/authSlice";
import "./POSHeader.css";

const POSHeader = ({
  businessName,
  fullName,
  isAdmin = false,
  activeTab = "VENTES",
  onChangeTab,
}) => {
  const tabs = [
    { key: "VENTES", label: "Ventes", icon: FaCashRegister, theme: "primary" },
    { key: "AVANCE", label: "Paiements", icon: FaMoneyBillWave, theme: "warning" },
    { key: "RETOURS", label: "Retours", icon: FaUndo, theme: "info" },
    { key: "STOCK", label: "Stock", icon: FaCubes, theme: "success" },
    { key: "PRODUCTS", label: "Articles", icon: FaProductHunt, theme: "success" },
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleLogout = () => {
    Swal.fire({
      title: t("auth.logoutConfirmTitle"),
      text: t("auth.logoutConfirmText"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("common.confirm"),
      cancelButtonText: t("common.cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(authActions.logout());
        Swal.fire({
          icon: "success",
          title: t("auth.logoutSuccess"),
          showConfirmButton: false,
          timer: 1200,
        }).then(() => navigate("/login"));
      }
    });
  };

  const handleBack = () => {
    navigate("/modules");
  };

  return (
    <div className="pos-header">
      {/* LEFT */}
      <div className="pos-header__left">
        {isAdmin && (
          <button
            type="button"
            className="pos-icon-btn"
            onClick={handleBack}
            title="Retour"
          >
            <FaArrowLeft />
          </button>
        )}

        <div className="pos-brand">
          <div className="pos-brand__logo">
            <FaStore />
          </div>
          <div className="pos-brand__meta">
            <div className="pos-brand__name">{businessName || "MATJARPOS"}</div>
            <div className="pos-brand__sub">Point de vente</div>
          </div>
        </div>
      </div>

      {/* CENTER */}
      {!isAdmin && (
        <div className="pos-header__center">
          <div className="pos-tabs">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const active = activeTab === tab.key;

              return (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => onChangeTab(tab.key)}
                  className={`pos-tab ${active ? "is-active" : ""} theme-${tab.theme}`}
                  title={tab.label}
                >
                  <span className="pos-tab__icon">
                    <Icon />
                  </span>
                  <span className="pos-tab__label">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* RIGHT */}
      <div className="pos-header__right">
        <div className="pos-user">
          <div className="pos-user__avatar">
            {(fullName || "U").trim().charAt(0).toUpperCase()}
          </div>
          <div className="pos-user__info">
            <div className="pos-user__name">{fullName || "Utilisateur"}</div>
            <div className="pos-user__role">{isAdmin ? "Admin" : "Caissier"}</div>
          </div>
        </div>

        <button
          type="button"
          className="pos-logout-btn"
          onClick={handleLogout}
          title="Déconnexion"
        >
          <FaSignOutAlt />
        </button>
      </div>
    </div>
  );
};

export default POSHeader;
